const Types = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  PRIMARYWHITE: 'primaryWhite',
  QUATERNARY: 'quaternary',
  QUINARY: 'quinary',
  TRAY: 'tray',
  OPTION: 'option',
  DEFAULT: 'default',
  DISABLED: 'disabled',
  DISABLEDTWO: 'disabledTwo',
  DISABLEDTHREE: 'disabledThree',
  GRADIENT: 'gradient',
};
const TypesList = Object.values(Types);
export { Types, TypesList };
export default Types;
